import { 
    FaArrowLeft,
    FaArrowRight,
    } from 'react-icons/fa'; // Import the left arrow icon
    import { useLanguage } from '../context/LanguageContext';
export default function ServiceCard(props){
    const { t, language} = useLanguage();
    console.log(props.data); // Debug: Check the data being passed
    return <div>
       
<div className="service-card" style={{direction:language==="en"?"ltr":"rtl"}}>
<img src={props.data.img} alt="service-photo"/>
<div className="service-description" style={{left:language==="en"?"4%":"4%"}}>
<h2>{props.data.title}</h2>
<p>{props.data.small_description}</p>
<a href='https://wa.me/+966557380850'  target="_blank"
          rel="noopener noreferrer">
<button className='btn btn-on-img-service btn-with-icon' style={{padding:language==="en"&&"5px 6px 5px"}}>{t('home.our_service_section.btn_sevice_request')}
    {language=="en"?
    
    <FaArrowRight className='arrow-icon-left' style={{margin:language==="en"&&"0 0 0 12px"}}/>
    :
    <FaArrowLeft className='arrow-icon-left' style={{margin:language==="en"&&"0 0 0 12px"}}/>
    }
    
    </button>
</a>
</div>
</div>

    </div>
    
}
